import { FinancialAccount } from "@common/types/financialAccount";
import { useUser } from "@hooks/useUser";
import { useCanManageWorkspace } from "./useCanManageWorkspace";

export function useCanRemoveFinancialAccount(account: FinancialAccount) {
    const canManageWorkspace = useCanManageWorkspace();
    const user = useUser();

    const accountBelongsToUser = account.integrationAccounts?.some(
        (integrationAccount) =>
            integrationAccount.connection?.user.id === user.id ||
            integrationAccount.integrationConnection?.createdByUserId ===
                user.id,
    );
    return canManageWorkspace || accountBelongsToUser;
}
